import { useSearchParams } from "react-router-dom";
import { getTasks } from "../../api/task";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useMemo } from "react";

const useTask = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    // Memo hóa giá trị mặc định để tránh tạo mới mỗi lần render
    const defaultStartDate = useMemo(() => new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().split('T')[0], []);
    const defaultEndDate = useMemo(
        () => new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0],
        []
    );

    const query = {
        projectId: searchParams.get('projectId') || '',
        startDate: searchParams.get('startDate') || defaultStartDate,
        endDate: searchParams.get('endDate') || defaultEndDate,
        page: Number(searchParams.get('page')) || 1,
        limit: Number(searchParams.get('limit')) || 10,
        search: searchParams.get('search') || '',
        uid: searchParams.get('uid') || '',
        sort: searchParams.get('sort') || 'desc',
        isActive: searchParams.get('isActive') || 'all',
    };

    useEffect(() => {
        // Nếu các tham số page, limit, startDate, endDate chưa có, set lại chúng
        if (
            !searchParams.get("page") ||
            !searchParams.get("limit") ||
            !searchParams.get("startDate") ||
            !searchParams.get("endDate")
        ) {
            setSearchParams({
                page: query.page.toString(),
                limit: query.limit.toString(),
                startDate: query.startDate,
                endDate: query.endDate,
            });
        }
    }, [searchParams, query.page, query.limit, query.startDate, query.endDate, setSearchParams]);

    const { data, isLoading, error } = useQuery({
        queryKey: ['tasks', query],
        queryFn: () => getTasks(query),
    });

    const handleSetQuery = (newQuery: typeof query) => {
        // Tạo một instance mới của URLSearchParams để đảm bảo tính bất biến
        const newParams = new URLSearchParams(searchParams);
        Object.keys(newQuery).forEach((key) => {
            newParams.set(key, newQuery[key as keyof typeof query].toString());
        });
        setSearchParams(newParams);
    };

    return { data, isLoading, error, handleSetQuery, query };
};

export { useTask };